import { CopyAll } from "@mui/icons-material";
import { Tooltip } from "@mui/material";

const CopyToClipboardButton = ({
  toolTip,
  value,
  onValueCopied,
}: {
  toolTip?: string;
  value: string;
  onValueCopied?: () => void;
}) => {
  const copyToClipboard = (value: string) => {
    navigator.clipboard.writeText(value);
    onValueCopied && onValueCopied();
  };

  return (
    <Tooltip title={toolTip || value}>
      <div onClick={() => copyToClipboard(value)} style={{ cursor: "pointer" }}>
        <CopyAll />
      </div>
    </Tooltip>
  );
};

export default CopyToClipboardButton;
